export const LOGIN_REDIRECT_URL = 'https://contalearn.ro/login';

export const redirectToLogin = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname === '/login') {
    return;
  }

  window.location.assign(LOGIN_REDIRECT_URL);
};